import i18n from '@/i18n';
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('TransportDriver-index-1992f2b81c6e1357c-1'),
    routerUrl: '/transportDriver',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./Driver')),
    children: [],
  },
];
